import { useState } from 'react';
import '../styles/brandAffinity.scss';

export default function BrandAffinityCard({ brandAffinityData }) {
  if (!brandAffinityData || brandAffinityData?.length === 0) {
    return null;
  }
  return (
    <div className="demographics-card">
      <h2>Their audience likes these brands</h2>
      <div className="brand-affinity-container">
        {brandAffinityData?.map((data) => (
          <BrandAffinity key={data.id} data={data} />
        ))}
      </div>
    </div>
  );
}

function BrandAffinity({ data }) {
  const [isError, setIsError] = useState(false);

  if (isError) {
    return null;
  }
  return (
    <div key={data.id} className="brand-affinity-logo-container">
      <div style={{ height: 60 }}>
        <img
          src={`https://logo.clearbit.com/${data.name.replace(/ /g, '')}.com`}
          alt={''}
          onError={(e) => {
            e.currentTarget.style.display = 'none';
            setIsError(true);
          }}
        />
      </div>
      <p>{data.name}</p>
    </div>
  );
}
